// Deutsche Texte (Referenz für alle anderen Sprachen; gleiche Struktur ist Pflicht)
const de = {
  meta: {
    siteName: "Nieder-Eschbacher Pflegedienst GmbH",
    titleSuffix: "Nieder-Eschbacher Pflegedienst",
    description:
      "Nieder-Eschbacher Pflegedienst GmbH, ambulanter Pflegedienst in Frankfurt am Main. Einfühlsame, kompetente Betreuung zuhause: Grundpflege, Behandlungspflege, Hauswirtschaft und 24-Stunden-Erreichbarkeit.",
    pages: {
      home: "",
      about: "Über uns",
      services: "Leistungen",
      news: "Aktuelles & Stellenangebote",
      contact: "Kontakt",
      imprint: "Impressum",
      privacy: "Datenschutzerklärung",
      notFound: "Seite nicht gefunden",
    },
  },

  common: {
    call: "Anrufen",
    callNow: "Jetzt anrufen:",
    contactUs: "Kontakt aufnehmen",
    bookConsultation: "Beratung vereinbaren",
    bookAppointment: "Termin vereinbaren",
    requestConsultation: "Beratung anfragen",
    aroundTheClock: "Rund um die Uhr:",
    reachable24h: "Rund um die Uhr erreichbar",
    certifiedStaff: "Examinierte Pflegekräfte",
    whatsapp: "WhatsApp",
    whatsappText: "Guten Tag, ich habe eine Frage zu Ihrem Pflegedienst.",
    whatsappNote: "Bitte senden Sie uns über WhatsApp keine Gesundheitsdaten. In Notfällen rufen Sie uns bitte an.",
    symbolImage: "Symbolbild",
    language: "Sprache",
    changeLanguage: "Sprache wählen",
    skipToContent: "Zum Inhalt springen",
    legalNote:
      "Diese Übersetzung dient der Information. Rechtlich verbindlich ist die deutsche Fassung.",
  },

  header: {
    topbar24h: "24 Std. erreichbar",
    topbarConsult: "Kostenlose & persönliche Beratung",
    mainNav: "Hauptnavigation",
    mobileNav: "Mobile Navigation",
    openMenu: "Menü öffnen",
    closeMenu: "Menü schließen",
  },

  nav: {
    home: "Start",
    about: "Über uns",
    services: "Leistungen",
    news: "Aktuelles",
    contact: "Kontakt",
    jobs: "Stellenanzeigen",
    imprint: "Impressum",
    privacy: "Datenschutz",
  },

  footer: {
    reach: "Erreichbarkeit",
    fax: "Fax:",
    emergency: "24-Std-Notruf:",
    navigation: "Navigation",
    legal: "Rechtliches",
    area: "Frankfurt am Main & Umgebung (Schwerpunkt Nieder-Eschbach)",
    rights: "Alle Rechte vorbehalten.",
  },

  floating: {
    whatsappLabel: "Uns über WhatsApp schreiben",
    callLabel: "Jetzt anrufen:",
    toTop: "Nach oben scrollen",
  },

  home: {
    eyebrow: "Ambulanter Pflegedienst · Frankfurt am Main",
    h1a: "Einfühlsame, kompetente",
    h1b: "Betreuung zuhause",
    lead:
      "Für ein sorgenfreies Leben, auch bei Pflegebedarf und Einschränkungen durch Alter und Krankheit. Wir nehmen uns Zeit für Sie.",
    heroImgAlt:
      "Pflegekraft des Nieder-Eschbacher Pflegedienstes legt einem lächelnden älteren Herrn die Hände auf die Schultern; daneben Logo und Leistungen: Grundpflege, Behandlungspflege, hauswirtschaftliche Unterstützung, individuelle Betreuung",
    badgeTitle: "Mit Herz & Zeit",
    badgeText: "Pflege, die sich Zeit nimmt",
    welcomeQuote:
      "Wir, das Team vom Nieder-Eschbacher Pflegedienst in Frankfurt am Main, freuen uns über Ihr Interesse. Wir machen uns Tag für Tag für Sie stark und bieten eine hochwertige Versorgung in der Privatsphäre Ihres Zuhauses. Unsere freundlichen Pflegekräfte nehmen sich Zeit für Sie.",
    features: [
      {
        icon: "Clock",
        title: "Wir nehmen uns Zeit",
        text: "Fürsorglicher Umgang ohne Hektik. Sie sollen sich bei uns wohlfühlen.",
        to: "about",
        cta: "Über uns",
      },
      {
        icon: "HeartHandshake",
        title: "Unsere Leistungen",
        text: "Grund- und krankenpflegerische Versorgung, individuell auf Sie abgestimmt.",
        to: "services",
        cta: "Leistungen",
      },
      {
        icon: "Newspaper",
        title: "Aktuelles & Stellenangebote",
        text: "Neuigkeiten und offene Stellen im Bereich Pflege.",
        to: "news",
        cta: "Aktuelles",
      },
    ],
    servicesEyebrow: "Unsere Leistungen",
    servicesTitle: "Individuelle Versorgung, ganz nach Ihren Bedürfnissen",
    servicesLead:
      "Von der Grundpflege bis zur 24-Stunden-Erreichbarkeit: Wir begleiten Sie umfassend in Ihrem gewohnten Zuhause.",
    valuesEyebrow: "Unsere Werte",
    valuesTitle: "Respekt, Fürsorge und ein verantwortungsvoller Umgang",
    valuesLead:
      "Respekt, Fürsorge und ein verantwortungsvoller Umgang sind unsere obersten Maximen. Wir behandeln jeden Menschen so, wie wir selbst behandelt werden möchten.",
    ctaTitle: "Unsicher, welchen Pflegegrad Sie haben?",
    ctaLead:
      "Gerne beraten wir Sie persönlich, bei uns oder bei Ihnen zuhause. Kostenlos und unverbindlich.",
  },

  values: [
    { icon: "Heart", label: "Individuelle Betreuung" },
    { icon: "BadgeCheck", label: "Examinierte Pflegekräfte" },
    { icon: "MessageCircle", label: "Persönliche Beratung" },
    { icon: "ShieldCheck", label: "Verantwortungsvoller Umgang" },
  ],

  services: [
    {
      id: "grundpflege",
      icon: "HandHeart",
      title: "Grundpflege",
      short: "Körperpflege, Mobilisation und Unterstützung im Alltag, mit Ruhe und Würde.",
      description:
        "Bei der Grundpflege unterstützen wir Sie einfühlsam bei allen alltäglichen Verrichtungen der Körperpflege und Mobilität. Wir nehmen uns Zeit und achten stets auf Ihre Würde und Selbstbestimmung.",
      points: [
        "Körperpflege (Waschen, Baden, Duschen)",
        "Mobilisation und Lagerung",
        "Inkontinenzversorgung",
        "Unterstützung bei der Nahrungsaufnahme",
        "An- und Auskleiden",
      ],
    },
    {
      id: "behandlungspflege",
      icon: "Stethoscope",
      title: "Behandlungspflege",
      short: "Medizinische Versorgung nach ärztlicher Anordnung, zuverlässig und fachgerecht.",
      description:
        "Die Behandlungspflege umfasst alle medizinisch notwendigen Maßnahmen und erfolgt stets auf ärztliche Anordnung. Unsere examinierten Pflegekräfte arbeiten eng mit Ihren Ärztinnen und Ärzten zusammen.",
      points: [
        "Medikamentengabe und -stellung",
        "Injektionen",
        "An- und Ausziehen von Kompressionsstrümpfen",
        "Moderne Wundversorgung",
        "Blutzucker- und Blutdruckkontrolle",
      ],
      note: "Behandlungspflege erfolgt stets auf ärztliche Anordnung.",
    },
    {
      id: "hauswirtschaft",
      icon: "Home",
      title: "Hauswirtschaft",
      short: "Wir kümmern uns um den Haushalt, damit Sie sich zuhause rundum wohlfühlen.",
      description:
        "Ein gepflegtes Zuhause trägt maßgeblich zum Wohlbefinden bei. Wir unterstützen Sie bei der Haushaltsführung, damit Sie sich in Ihren eigenen vier Wänden entspannt und geborgen fühlen.",
      points: [
        "Einkaufen und Besorgungen",
        "Zubereitung von Mahlzeiten",
        "Wäscheversorgung",
        "Reinigungsarbeiten in der Wohnung",
      ],
    },
    {
      id: "betreuung",
      icon: "Users",
      title: "Zusätzliche Betreuungsleistungen",
      short: "Gemeinsame Zeit, Gespräche und Aktivierung für mehr Lebensfreude.",
      description:
        "Neben der pflegerischen Versorgung ist uns die menschliche Zuwendung besonders wichtig. Wir entlasten pflegende Angehörige und schenken Ihnen Zeit für schöne, gemeinsame Momente.",
      points: [
        "Entlastung pflegender Angehöriger",
        "Orientierungstraining",
        "Kommunikation und Gesellschaft",
        "Biographiearbeit",
      ],
    },
    {
      id: "anleitung",
      icon: "GraduationCap",
      title: "Anleitung pflegender Angehöriger",
      short: "Wir unterstützen Ihre Angehörigen dabei, Sie zu unterstützen.",
      description:
        "Pflegende Angehörige leisten Großartiges. Wir geben Ihnen praktische Anleitung und Sicherheit im Umgang mit der Pflege, individuell und verständlich in Ihrem Zuhause.",
      points: [
        "Praktische Pflegeanleitung zuhause",
        "Beratung zu Hilfsmitteln",
        "Tipps für den pflegegerechten Alltag",
        "Sicherheit im Umgang mit der Pflege",
      ],
    },
    {
      id: "erreichbarkeit",
      icon: "Clock",
      title: "24-Stunden-Erreichbarkeit",
      short: "Rund um die Uhr mobil erreichbar, damit Sie sich sicher fühlen.",
      description:
        "In Notfällen sind wir für Sie da, zu jeder Tages- und Nachtzeit. Unter unserer mobilen Notrufnummer erreichen Sie uns rund um die Uhr.",
      points: [
        "Mobiler Notruf: 0177 / 7202956",
        "Alternativ: 0157 / 36442746",
        "Schnelle Hilfe im Ernstfall",
        "Sicherheit für Sie und Ihre Angehörigen",
      ],
    },
  ],

  servicesPage: {
    eyebrow: "Leistungen",
    title: "Umfassende Pflege, individuell für Sie",
    subtitle:
      "Wir bieten Ihnen ein breites Spektrum an pflegerischen und hauswirtschaftlichen Leistungen, das wir genau auf Ihre Situation abstimmen.",
    shortLongTitle: "Kurzzeit- und Dauerpflege",
    shortLongText:
      "Ob vorübergehend nach einem Krankenhausaufenthalt oder dauerhaft: Wir passen unsere Betreuung flexibel an Ihre Lebenssituation an. So erhalten Sie genau die Unterstützung, die Sie gerade benötigen.",
    adviceTitle: "Beratung zu Pflegegraden & Pflegekasse",
    adviceText:
      "Das Pflegesystem ist komplex. Wir erklären Ihnen verständlich, welche Leistungen Ihnen zustehen, und unterstützen Sie bei der Beantragung bei der Pflegekasse, Schritt für Schritt.",
    ctaTitle: "Kostenlose Beratung anfragen",
    ctaLead: "Wir beraten Sie gerne persönlich und unverbindlich, bei uns oder bei Ihnen zuhause.",
  },

  about: {
    eyebrow: "Über uns",
    title: "Menschen, die sich Zeit nehmen",
    subtitle:
      "Lernen Sie unser Team und unsere Philosophie kennen. Uns prägen Zeit, Respekt, Fürsorge und echte Menschlichkeit.",
    introTitle: "Ihr Wohlbefinden steht im Mittelpunkt",
    intro: [
      "Wir sind das Team vom Nieder-Eschbacher Pflegedienst in Frankfurt am Main. Tag für Tag machen wir uns für die Menschen stark, die uns ihr Vertrauen schenken. Für uns ist Pflege weit mehr als eine Aufgabe. Sie ist eine Herzensangelegenheit.",
      "Unsere freundlichen, examinierten Pflegekräfte nehmen sich bewusst Zeit für Sie. Denn eine gute Betreuung braucht Ruhe, Aufmerksamkeit und ein offenes Ohr, ohne Hektik.",
      "Wir betreuen Sie dort, wo Sie sich am wohlsten fühlen: in Ihrem eigenen Zuhause, in Ihrer vertrauten Umgebung. So bleibt Ihre Selbstständigkeit erhalten und Ihre Privatsphäre gewahrt.",
    ],
    teamImgAlt: "Pflegekraft hält fürsorglich die Hände einer älteren Dame im Rollstuhl (Symbolbild)",
    valuesTitle: "Werte, die uns leiten",
    valuesLead: "Respekt, Fürsorge und ein verantwortungsvoller Umgang sind unsere obersten Maximen.",
    pillars: [
      { icon: "Clock", title: "Zeit", text: "Wir arbeiten ohne Hektik und schenken Ihnen echte Aufmerksamkeit." },
      { icon: "Heart", title: "Fürsorge", text: "Jeder Mensch ist einzigartig. Unsere Betreuung ist es auch." },
      { icon: "Home", title: "Zuhause", text: "Pflege in der vertrauten Umgebung, die Sicherheit gibt." },
    ],
    ctaTitle: "Lernen Sie uns kennen",
    ctaLead: "Wir freuen uns auf ein persönliches Gespräch mit Ihnen.",
  },

  newsPage: {
    eyebrow: "Aktuelles",
    title: "Neuigkeiten & Stellenangebote",
    subtitle:
      "Neuigkeiten aus unserem Pflegedienst und offene Stellen für alle, die Teil unseres Teams werden möchten.",
    newsTitle: "Neuigkeiten",
    newsLead: "Aktuelle Informationen aus unserem Pflegedienst.",
    careerEyebrow: "Karriere",
    careerTitle: "Werden Sie Teil unseres Teams",
    careerLead:
      "Sie lieben die Pflege und möchten in einem herzlichen Team mit echter Zeit für den Menschen arbeiten? Dann freuen wir uns auf Ihre Bewerbung.",
    applyNow: "Jetzt bewerben",
    applySubject: "Bewerbung: Pflegehelfer/in (m/w/d)",
    tasks: "Ihre Aufgaben",
    profile: "Ihr Profil",
    offer: "Wir bieten",
    interested: "Interesse geweckt? Senden Sie Ihre Bewerbung an",
    orCall: "oder rufen Sie uns an unter",
    questions: "Fragen? Kontaktieren Sie uns",
  },

  news: [
    {
      id: "willkommen",
      date: "2026-09-21",
      category: "Neuigkeiten",
      title: "Herzlich willkommen auf unserer neuen Website",
      excerpt:
        "Wir freuen uns, Ihnen unseren Pflegedienst und unsere Leistungen ab sofort auch online vorstellen zu dürfen: übersichtlich, klar und immer erreichbar.",
      body: "Unser Ziel ist es, Ihnen und Ihren Angehörigen alle wichtigen Informationen rund um die Pflege zuhause bequem zugänglich zu machen. Bei Fragen erreichen Sie uns jederzeit telefonisch oder über unser Kontaktformular.",
    },
    {
      id: "pflegeberatung",
      date: "2025-10-28",
      category: "Beratung",
      title: "Kostenlose Pflegeberatung bei uns oder bei Ihnen zuhause",
      excerpt:
        "Unsicher, welcher Pflegegrad zu Ihnen passt? Wir beraten Sie gerne persönlich und unverbindlich zu allen Fragen rund um Pflegekasse und Pflegegrade.",
      body: "Das deutsche Pflegesystem ist komplex. Wir nehmen uns Zeit, erklären Ihnen die Möglichkeiten in Ruhe und unterstützen Sie bei der Beantragung von Leistungen. Vereinbaren Sie einfach einen Termin.",
    },
    {
      id: "team-verstaerkung",
      date: "2025-10-05",
      category: "Team",
      title: "Wir wachsen und suchen Verstärkung",
      excerpt:
        "Unser Team wächst stetig. Werden Sie Teil eines herzlichen Kollegiums, das Pflege mit Zeit und Respekt lebt.",
      body: "Wir bieten faire Arbeitsbedingungen, wertschätzenden Umgang und echte Zeit für die Menschen, die wir betreuen. Schauen Sie sich unsere aktuellen Stellenangebote an.",
    },
  ],

  jobs: [
    {
      id: "pflegehelfer",
      title: "Pflegehelfer/in (m/w/d)",
      type: "Teilzeit oder Vollzeit",
      location: "Frankfurt am Main, Nieder-Eschbach",
      intro:
        "Zur Verstärkung unseres Teams suchen wir eine/n Pflegehelfer/in, die/der unsere Werte Zeit, Respekt und Fürsorge mit Leben füllt. Auch Quereinsteiger mit Herz sind willkommen.",
      tasks: [
        "Unterstützung bei der Grundpflege unserer Klientinnen und Klienten",
        "Hilfe bei Mobilisation und im Alltag",
        "Begleitung und menschliche Zuwendung",
        "Enge Zusammenarbeit im Pflegeteam",
      ],
      requirements: [
        "Freude an der Arbeit mit Menschen und Einfühlungsvermögen",
        "Zuverlässigkeit, Verantwortungsbewusstsein und Teamgeist",
        "Erste Erfahrung in der Pflege von Vorteil (kein Muss)",
        "Führerschein Klasse B von Vorteil",
      ],
      offer: [
        "Faire, pünktliche Vergütung",
        "Wertschätzendes und herzliches Team",
        "Echte Zeit für die Pflege, ohne Hektik",
        "Einarbeitung sowie Fort- und Weiterbildungen",
      ],
    },
  ],

  contact: {
    eyebrow: "Kontakt",
    title: "Wir sind für Sie da",
    subtitle:
      "Ob Fragen zur Pflege, Terminwunsch oder Beratung: Nehmen Sie unverbindlich Kontakt mit uns auf. Wir freuen uns auf Sie.",
    formTitle: "Schreiben Sie uns",
    formLead: "Wir melden uns schnellstmöglich bei Ihnen zurück.",
    name: "Name",
    namePlaceholder: "Ihr Name",
    email: "E-Mail",
    emailPlaceholder: "name@beispiel.de",
    phone: "Telefon",
    phonePlaceholder: "Ihre Telefonnummer",
    message: "Nachricht",
    messagePlaceholder: "Wie können wir Ihnen helfen?",
    consentBefore: "Ich habe die",
    consentLink: "Datenschutzerklärung",
    consentAfter:
      "gelesen und willige ein, dass meine Angaben (auch etwaige gesundheitsbezogene Informationen in meiner Nachricht) zur Bearbeitung meiner Anfrage verarbeitet werden. Die Einwilligung kann ich jederzeit widerrufen.",
    submit: "Nachricht senden",
    sending: "Wird gesendet…",
    subject: "Kontaktanfrage über Website",
    errName: "Bitte geben Sie Ihren Namen an.",
    errEmail: "Bitte geben Sie eine gültige E-Mail-Adresse an.",
    errMessage: "Bitte schreiben Sie uns eine kurze Nachricht.",
    errConsent: "Bitte stimmen Sie der Datenschutzerklärung zu.",
    toastCheck: "Bitte überprüfen Sie Ihre Eingaben.",
    toastSuccess: "Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.",
    toastError: "Es ist ein Fehler aufgetreten. Bitte rufen Sie uns an.",
    successTitle: "Vielen Dank!",
    successText: "Ihre Nachricht wurde erfolgreich übermittelt. Wir melden uns zeitnah bei Ihnen.",
    sendAnother: "Weitere Nachricht senden",
    reachTitle: "So erreichen Sie uns",
    address: "Adresse",
    phoneLabel: "Telefon",
    fax: "Fax",
    emergency: "24-Stunden-Notruf",
    alternatively: "alternativ",
    emailLabel: "E-Mail",
    hoursTitle: "Erreichbarkeit",
    hours: "Montag bis Freitag: 08:00 bis 17:00 Uhr",
    careAndEmergency: "Pflegerische Versorgung & Notruf:",
    aroundTheClock: "rund um die Uhr",
    mapTitle: "So finden Sie uns",
    mapIframeTitle: "Standort Nieder-Eschbacher Pflegedienst auf Google Maps",
    mapLoad: "Karte laden",
    mapNotice:
      "Aus Datenschutzgründen wird die Google-Maps-Karte erst nach Ihrer Zustimmung geladen. Dabei werden Daten an Google übertragen.",
    mapButton: "Karte laden & Standort anzeigen",
    mapAlt: "Alternativ in Google Maps öffnen",
  },

  reviews: {
    eyebrow: "Bewertungen",
    title: "Das sagen Angehörige und Patienten",
    emptyLead: "Ihre Erfahrung hilft anderen Familien in Frankfurt, den passenden Pflegedienst zu finden.",
    countOn: "Bewertungen auf",
    source: "Öffentliche Bewertungen aus unserem Google-Unternehmensprofil.",
    asOf: "Stand:",
    all: "Alle Bewertungen auf Google",
    write: "Bewertung schreiben",
    on: "auf",
    starsLabel: "von 5 Sternen",
  },

  notFound: {
    title: "Seite nicht gefunden",
    subtitle: "Fehler 404",
    text: "Die aufgerufene Seite existiert nicht oder wurde verschoben.",
    home: "Zur Startseite",
  },

  imprint: {
    title: "Impressum",
    subtitle: "Angaben gemäß § 5 DDG",
    company: "Angaben gemäß § 5 DDG",
    country: "Deutschland",
    representedBy: "Vertreten durch",
    managingDirector: "Geschäftsführerin",
    contact: "Kontakt",
    phone: "Telefon",
    fax: "Fax",
    email: "E-Mail",
    register: "Registereintrag",
    registerCourt: "Registergericht",
    registerNumber: "Registernummer",
    taxNumber: "Steuernummer",
    licence: "Zulassung und Aufsichtsbehörde",
    licenceText:
      "Zugelassener ambulanter Pflegedienst durch Versorgungsvertrag nach § 72 SGB XI mit den Landesverbänden der Pflegekassen in Hessen.",
    authorityText:
      "Zuständige Aufsichtsbehörde nach dem Hessischen Gesetz über Betreuungs- und Pflegeleistungen (HGBP):",
    dispute: "Verbraucherstreitbeilegung",
    disputeText:
      "Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen (§ 36 VSBG).",
    responsible: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
    credit: "Konzeption und technische Umsetzung",
    liabilityContent: "Haftung für Inhalte",
    liabilityContentText:
      "Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen (Art. 8 Verordnung (EU) 2022/2065, Digital Services Act). Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.",
    liabilityLinks: "Haftung für Links",
    liabilityLinksText:
      "Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.",
    copyright: "Urheberrecht",
    copyrightText:
      "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.",
  },

  // Datenschutzerklärung: Platzhalter {email}, {retention}, {dpoName}, {dpoEmail}, {dpoPhone};
  // Links als [Text](URL); **fett** für Hervorhebungen.
  privacy: {
    title: "Datenschutzerklärung",
    subtitle: "Informationen zur Verarbeitung Ihrer personenbezogenen Daten gemäß DSGVO",
    retention: "sechs Monate",
    lastUpdated: "Stand: Oktober 2026",
    controller: {
      title: "1. Verantwortlicher",
      lead: "Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:",
      representedBy: "vertreten durch die Geschäftsführerin",
      phone: "Telefon",
      fax: "Fax",
      email: "E-Mail",
    },
    dpo: {
      title: "Datenschutzbeauftragte/r",
      lead: "Unsere Datenschutzbeauftragte bzw. unseren Datenschutzbeauftragten erreichen Sie unter:",
    },
    general: {
      title: "2. Allgemeines zur Datenverarbeitung",
      p: [
        "Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie zur Bearbeitung Ihrer Anfragen erforderlich ist. Rechtsgrundlagen sind Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. b DSGVO (Vertrag bzw. Vertragsanbahnung) und Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem sicheren und stabilen Betrieb dieser Website).",
        "Diese Website setzt **keine Cookies**, speichert keine Informationen auf Ihrem Endgerät (§ 25 TDDDG) und verwendet keine Analyse-, Tracking- oder Werbedienste. Schriften und Bilder werden von unserem eigenen Webangebot ausgeliefert; beim Aufruf der Seiten werden keine Daten an Schriftarten- oder Bilddienste Dritter übermittelt. Eine ausschließlich automatisierte Entscheidungsfindung einschließlich Profiling (Art. 22 DSGVO) findet nicht statt.",
      ],
    },
    hosting: {
      title: "3. Hosting und Server-Logfiles",
      ownIntro:
        "Diese Website wird in unserem Auftrag von {operator} auf einem Server in Deutschland betrieben. Rechenzentrums- und Serveranbieter ist {provider}.",
      logs: "Bei jedem Aufruf werden technisch notwendige Verbindungsdaten verarbeitet: IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite, übertragene Datenmenge, Browsertyp und -version, Betriebssystem sowie die zuvor besuchte Seite (Referrer). Diese Daten werden nicht mit anderen Datenquellen zusammengeführt und dienen ausschließlich der Auslieferung der Website, der Sicherheit und der Fehleranalyse. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Server-Logfiles werden nur so lange gespeichert, wie dies für den sicheren Betrieb erforderlich ist, und anschließend gelöscht oder anonymisiert.",
      ownLegal:
        "Mit dem Betreiber und dem Rechenzentrumsanbieter bestehen Auftragsverarbeitungsverträge nach Art. 28 DSGVO. Eine Übermittlung in Drittländer findet im Rahmen des Hostings nicht statt.",
    },
    form: {
      title: "4. Kontaktformular",
      p: [
        "Wenn Sie uns über das Kontaktformular eine Anfrage senden, verarbeiten wir die von Ihnen eingegebenen Daten (Name, E-Mail-Adresse, optional Telefonnummer sowie Ihre Nachricht) zur Bearbeitung Ihrer Anfrage und für mögliche Anschlussfragen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Anbahnung eines Pflege- bzw. Betreuungsverhältnisses) und, soweit Sie uns gesundheitsbezogene Angaben mitteilen, Ihre ausdrückliche Einwilligung nach Art. 9 Abs. 2 lit. a DSGVO, die Sie über das Kontrollkästchen im Formular erteilen.",
        "Pflichtangaben sind Name, E-Mail-Adresse und Ihre Nachricht; die Telefonnummer ist freiwillig. Ohne die Pflichtangaben können wir Ihre Anfrage nicht bearbeiten. Sie erreichen uns dann jederzeit telefonisch. Die Übertragung erfolgt verschlüsselt (TLS). Ihre Anfrage wird ausschließlich auf einem von uns beauftragten Server in Deutschland gespeichert und nicht an Dritte weitergegeben. Wir löschen die Daten spätestens {retention} nach abschließender Bearbeitung Ihrer Anfrage, sofern kein Betreuungsverhältnis zustande kommt und keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, z. B. per E-Mail an {email}.",
      ],
    },
    emailPhone: {
      title: "5. Kontaktaufnahme per E-Mail, Telefon oder WhatsApp",
      p: [
        "Wenn Sie uns per E-Mail oder telefonisch kontaktieren, verarbeiten wir Ihre Angaben zur Bearbeitung des Anliegens (Art. 6 Abs. 1 lit. b und lit. f DSGVO). Bitte beachten Sie, dass unverschlüsselte E-Mails auf dem Übertragungsweg von Dritten eingesehen werden können; für gesundheitsbezogene Angaben empfehlen wir das Telefon oder ein persönliches Gespräch.",
        "E-Mails an {email} erreichen uns über einen Weiterleitungsdienst: Zustelldienst ist {forwarder}, das Postfach liegt bei {mailbox}. Dabei werden Absenderadresse, Betreff und Inhalt Ihrer Nachricht verarbeitet und auch in die USA übermittelt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Senden Sie uns deshalb bitte keine Gesundheitsdaten per E-Mail und nutzen Sie dafür das Telefon oder ein persönliches Gespräch.",
        "Auf unserer Website finden Sie einen Link, über den Sie uns per WhatsApp schreiben können. Anbieter ist WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland. Der Link ist ein einfacher Verweis: Erst wenn Sie ihn anklicken, wird eine Verbindung zu WhatsApp hergestellt und Ihre Mobilfunknummer sowie der Inhalt Ihrer Nachricht an WhatsApp übermittelt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO. WhatsApp verarbeitet Daten auch außerhalb der EU; Meta ist nach dem EU-US Data Privacy Framework zertifiziert. Bitte senden Sie uns über WhatsApp keine Gesundheitsdaten und nutzen Sie in Notfällen das Telefon.",
      ],
    },
    applications: {
      title: "6. Bewerbungen",
      p: [
        "Bewerbungen auf unsere Stellenangebote richten Sie per E-Mail an uns. Wir verarbeiten Ihre Bewerbungsunterlagen ausschließlich zur Durchführung des Bewerbungsverfahrens (Art. 6 Abs. 1 lit. b DSGVO, § 26 BDSG). Nach Abschluss des Verfahrens werden die Unterlagen spätestens nach sechs Monaten gelöscht, es sei denn, Sie haben in eine längere Aufbewahrung eingewilligt oder es kommt ein Arbeitsverhältnis zustande.",
      ],
    },
    maps: {
      title: "7. Google Maps (Zwei-Klick-Lösung)",
      p: [
        "Auf der Kontaktseite bieten wir eine Karte des Dienstes Google Maps an. Anbieter ist Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Die Karte wird **erst nach Ihrem ausdrücklichen Klick** auf „Karte laden“ geladen; vorher werden keine Daten an Google übermittelt. Mit dem Klick willigen Sie ein (Art. 6 Abs. 1 lit. a DSGVO), dass Google Ihre IP-Adresse und Nutzungsdaten verarbeitet und ggf. an Server der Google LLC in den USA überträgt; dabei kann Google Cookies auf Ihrem Endgerät setzen. Google ist nach dem EU-US Data Privacy Framework zertifiziert und verwendet ergänzend Standardvertragsklauseln. Ihre Einwilligung gilt nur für den jeweiligen Seitenaufruf. Weitere Informationen: [policies.google.com/privacy](https://policies.google.com/privacy).",
      ],
    },
    rights: {
      title: "8. Ihre Rechte",
      lead: "Sie haben gegenüber uns folgende Rechte hinsichtlich Ihrer personenbezogenen Daten:",
      items: [
        "Auskunft (Art. 15 DSGVO)",
        "Berichtigung (Art. 16 DSGVO)",
        "Löschung (Art. 17 DSGVO)",
        "Einschränkung der Verarbeitung (Art. 18 DSGVO)",
        "Datenübertragbarkeit (Art. 20 DSGVO)",
        "Widerspruch gegen Verarbeitungen auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (Art. 21 DSGVO)",
        "Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)",
      ],
      how: "Zur Ausübung Ihrer Rechte genügt eine formlose Mitteilung an {email} oder postalisch an die oben genannte Anschrift.",
    },
    authority: {
      title: "9. Beschwerderecht bei der Aufsichtsbehörde",
      lead: "Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren (Art. 77 DSGVO). Für uns zuständig ist:",
      name: "Der Hessische Beauftragte für Datenschutz und Informationsfreiheit",
      address: "Gustav-Stresemann-Ring 1, 65189 Wiesbaden",
      url: "https://datenschutz.hessen.de",
      urlLabel: "datenschutz.hessen.de",
    },
    security: {
      title: "10. Datensicherheit",
      p: [
        "Diese Website wird ausschließlich über eine verschlüsselte HTTPS-Verbindung (TLS) ausgeliefert. Wir setzen technische und organisatorische Maßnahmen ein, um Ihre Daten gegen Verlust, Manipulation und unberechtigten Zugriff zu schützen, und passen diese fortlaufend an den Stand der Technik an.",
      ],
    },
    changes: {
      title: "11. Änderungen dieser Datenschutzerklärung",
      p: [
        "Wir passen diese Datenschutzerklärung an, wenn sich die Rechtslage oder unser Webangebot ändert. Es gilt jeweils die hier veröffentlichte Fassung.",
      ],
    },
  },
};

export default de;
